module.exports = __webpack_public_path__ + "img/winner.e79d26de.png";